import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ErrorState = ({ message, onRetry }) => {
  return (
    <div className="bg-card border border-destructive/20 rounded-lg p-8 text-center">
      <div className="flex items-center justify-center w-16 h-16 bg-destructive/10 rounded-full mx-auto mb-4">
        <Icon name="AlertCircle" size={32} color="var(--color-destructive)" strokeWidth={2} />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">Driver Not Found</h3>
      <p className="text-sm text-muted-foreground max-w-md mx-auto mb-6">
        {message || "No driver record found for this phone number. Please verify the number and try again."}
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          variant="outline"
          size="default"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onRetry}
        >
          Try Another Number
        </Button>
        <Button
          variant="default"
          size="default"
          iconName="Phone"
          iconPosition="left"
          onClick={() => window.location.href = 'tel:+18005550100'}
        >
          Contact Support
        </Button>
      </div>
    </div>
  );
};

export default ErrorState;